import { Text } from 'app/components/design-system-components/typography'
import theme from 'app/match/applicationReportPDF/assets/theme'

export const SNUG_MATCH_LABEL =
  'Snug Match Score is based on property owner preferences, property data, rental application attributes (start date, rent and term) and renter profile completion (non-discriminatory universal platform wide weighted contribution from the renter profile).'

export const DISCRIMINATION_LEARN_MORE_LINK =
  'https://help.snug.com/hc/en-us/articles/360000771916-Discrimination'

export const RENTER_DISCRIMINATION_LEARN_MORE_LINK =
  'https://help.snug.com/hc/en-us/articles/360003681475'

export const RENTAL_REFERENCE_URL_STR = 'rr'
export const SLASH_RENTAL_REFERENCE_URL_STR = '/rr'

export const hasRRUrlStrInPathname = () => {
  return window.location.pathname.endsWith(SLASH_RENTAL_REFERENCE_URL_STR)
}

export const APPLICATION_BY_STAGE = 'applicationbystage'
export const PROSPECT_SUMMARY = 'prospectSummary'

const basePMNumber = '73,000'
const baseAgencyNumber = '34,000'

export const MarketingPMCount = basePMNumber + '*'
export const MarketingPMCountPlus = basePMNumber + '+*'
export const MarketingPMCountCaveatText =
  '*Real estate agents and owners who have used Snug for rental references, applications or leasing software in the 12 months to 31 Dec 2023.'
export const MarketingAgencyCount = baseAgencyNumber + '*'
export const MarketingAgencyText =
  '*Real estate agency personnel who have used Snug for rental references, applications or leasing software in the 12 months to 31 Dec 2023.'

export const BG_CHECK_USUAL_PRICE = '$25'
export const BG_CHECK_RENTER_PRICE_NUM = '19.95'
export const BG_CHECK_SPECIAL_PRICE = '$' + BG_CHECK_RENTER_PRICE_NUM

export const ARCHIVED_STATUS = 100
export const ONLIST_INCOMPLETE = 101

export const STATUS_ONLIST_UNKNOWN = 0
export const STATUS_ONLIST_INCOMPLETE = 10
export const STATUS_ONLIST_COMPLETE = 100

export const ONLIST_INCOMPLETE_TEXT = 'Onlist incomplete'

export const RENTAL_REFERNCES_CAMPAIGN_JULY_2022 = 'rental_references_July2022'
export const RENTAL_REFERNCES_CAMPAIGN_JUNE_2023 = 'rental_references_June2023'

export const MarketingRRLiteVideoLink =
  'https://player.vimeo.com/video/744846308?h=ea63311084'

export const PrimaryAccessReference = 'Access my references'

// sensitive docs
export const AUTO_REMOVE_OUTDATED_DOCUMENTS_DAYS = 60
export const DOCUMENT_SENSITIVE_WARNING = `To enhance data security and privacy, sensitive profile data and applications are auto-withdrawn and deleted.`
export const UPLOADED_SENSITIVE_DOCUMENTS_NOTE =
  'Sensitive documents deleted after 60 days'
export const PRIVACY_SECURITY_LEARN_MORE_LINK =
  'https://help.snug.com/hc/en-us/articles/4633796966799-Data-Security-and-Privacy'

export const BGCheckPriceForManagers = 11.95

export const AUTO_DELETE_SENSITIVE = `We automatically delete Sensitive Information and Documents after ${AUTO_REMOVE_OUTDATED_DOCUMENTS_DAYS} days.`

export const DISCLOSURE_QUESTIONS_DISPLAY = {
  consumer_renting_guide: 'consumer renting guide',
  property_disclosures: 'property disclosures',
  statement_of_information: 'statement of information',
}

export const SNUG_SAFETY_CENTRE_URL = 'https://snug.com/safety/'

export const KEEP_SAFE_ONLINE =
  'Keep Safe Online: be alert to phishing, fake ads or calls and report suspicious activity. Snug never requests login, rent or bond payments.'

export const TRADEMARK_FOOTER_CONTENT_LOGIN_COMPS_TEXT = (
  <span>
    . &copy; Snug Technologies Pty Ltd. 'Snug' is a Trademark. All rights
    reserved.
  </span>
)

export const TRADEMARK_FOOTER_CONTENT_TEXT = (
  <span>
    &copy; Snug Technologies Pty Ltd ABN 82 616 484 292. 'Snug' is a Trademark.
    All rights reserved.
  </span>
)

export const ADVERTISED_RENT_TOOLTIP_TEXT = `Rent bidding is banned in most states: property managers must not ask for or invite rent offers above that advertised but they may accept a higher, unprompted offer made by an applicant. Rent adjustment may be warranted with a lease start after the property's available date or with inclusions such as gardening.`

export const RENTAL_HISTORY_NORMAL_APPLICATION_MESSAGE_NOTE =
  ' Note: a rental reference request will be sent to past property managers.'
export const RENTAL_HISTORY_BALLOT_APPLICATION_MESSAGE_NOTE =
  ' Note: a rental reference request will be sent to past property managers if you are successfully selected in the ballot.'

export const RENTAL_HISTORY_ADD_NORMAL_APP_SEND_RR_NOW_MSG =
  'Yes, contact my residential references now (untick to defer until application submitted)'

export const RENTAL_HISTORY_CONSENT_DISCLOSURE =
  'By adding your referee details you confirm they have consented to be contacted.'

export const RENTAL_HISTORY_ADD_BALLOT_APP_SEND_RR_NOW_MSG =
  'Yes, contact my residential reference immediately (if not now, they will be contacted if you are selected in the ballot)'

export const VARC_BALLOT_APPLICATION_START_PAGE_TERM_AND_CONDITIONS = [
  'Eligible applications will enter the ballot once. This allows all successful, eligible applicants an equal chance of securing their chosen home.',
  'You may choose to apply for multiple homes for which you are eligible, however it is important that applicants only apply for properties that meet their needs.',
  <div>
    On the Snug Platform, for privacy and security Sensitive Data is removed
    automatically after 60 days{' '}
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={PRIVACY_SECURITY_LEARN_MORE_LINK}
    >
      learn more
    </a>
  </div>,
]

export const BALLOT_PROPERTY_PAGE_ENDING = (
  <>
    <p>
      Once you correctly submit your application, your application will enter a
      ballot for that home. A ballot is where applications will be randomly
      chosen from a list. In this way, all eligible applications have an equal
      chance of being offered an affordable home.
    </p>
    <br />
    <p>
      To start the application process, please click on the green button ‘Enter
      Ballot’.
    </p>
  </>
)

export const VARCBallotTextPropertyPage = () => (
  <>
    <p>
      This is a Homes Victoria affordable home. Your application will ask for
      information to make sure you are eligible.
    </p>
    <br />
    {BALLOT_PROPERTY_PAGE_ENDING}
  </>
)

export const QldAffordableBallotTextPropertyPage = () => (
  <>
    <p>
      This property is accepting ballot entries. Your application will ask for
      information to make sure you are eligible.
    </p>
    <br />
    {BALLOT_PROPERTY_PAGE_ENDING}
  </>
)

export const VARC_POST_APPLICATION_SUBMISSION_TEXT =
  'If you’re successful in the ballot, you and your co-applicants will be required to finalise an application with 48 hours. Get started early to make sure you’re ready.'

export const APPLICATION_LEASE_TERM_TITLE =
  'Lease Term (select your preference)'

export const VARC_BALLOT_DOCUMENT_UPLOAD_INFO_ALERT =
  'Document upload is optional and will be required within 48 hours if you’re successful. Successful applicants will have the opportunity for their documents to be sighted in person if they choose not to upload.'

//VARC and normal renter header guidance
export const ADDRESS_HISTORY_HEADER_GUIDANCE =
  'Add your current address and/or previous rental address if any.'

export const ADDRESS_HISTORY_HEADER_ALERT =
  'Please include all living arrangements e.g. renting, living with family or friends, ownership etc.'

export const QLD_ADDRESS_HISTORY_REQUIREMENT =
  'Add your two (2) previous rental history addresses.'

export const QLD_ADDRESS_HISTORY_HEADER_ALERT = `${QLD_ADDRESS_HISTORY_REQUIREMENT} If you do not have rental history, leave blank. If you have existing non-rental address history, it will not be included in your application.`

export const employmentContactDetailsGuidance = (contactLabel) =>
  `Please provide your ${contactLabel.toLowerCase()} contact details. ` +
  'Snug will send a request to the contact to confirm the provided employment details for the property manager. ' +
  EMPLOYMENT_CONFIRMATION_NOTICE_SOUTH_AUSTRALIA

export const EMPLOYMENT_CONFIRMATION_NOTICE_SOUTH_AUSTRALIA =
  'In South Australia, an employment confirmation or payslips may be used to confirm income.'
export const EMPLOYMENT_HISTORY_HEADER_GUIDANCE =
  'Add your current employment details and for self-employed add accountant to enable verification. ' +
  EMPLOYMENT_CONFIRMATION_NOTICE_SOUTH_AUSTRALIA

export const EMPLOYMENT_HISTORY_HEADER_FORM22 =
  'Add your current employment details, if you cannot provide this please provide other details about your ability to pay rent such as previous employment, or documents in the following Income or Financial information section.'

export const ADD_EMPLOYMENT_HISTORY_HEADER =
  'Add employment details to demonstrate rental affordability. We’ll send an Employment Confirmation request to your employer. ' +
  EMPLOYMENT_CONFIRMATION_NOTICE_SOUTH_AUSTRALIA

export const ADD_EMPLOYMENT_HISTORY_HEADER_FORM22 =
  EMPLOYMENT_HISTORY_HEADER_FORM22

export const TOTAL_INCOME_EXTRA_TEXT = '(After tax)'
export const TOTAL_INCOME_EXTRA_TEXT_FROM22 = '(Gross)'

export const INCOME_HEADER_GUIDANCE =
  'Demonstrate your affordability with proof of income sources (eg. payslip, bank statement/balance or Centrelink benefits).'
export const INCOME_HEADER_GUIDANCE_QLD =
  'Please provide two documents to verify your financial ability to pay rent e.g. payslip, bank statement/balance or other financial documents (which may vary depending on individual circumstances, as requested by the property manager/owner). ' +
  'If not receiving regular income (e.g. self-employed, casual, freelance, between employment) please provide other financial documents e.g. previous payslip, Centrelink statement/letter, proof of savings/assets.'

export const PETS_DETAIL_HEADER_GUIDANCE =
  'Add your pet details to complete your renter profile.'

export const PETS_DETAIL_HEADER_GUIDANCE_ADD_PET =
  'Add your pet details to complete your renter profile. Do you have shared pets? Add pets to one profile only, either the Pet Owner or the Primary Applicant’s profile. Avoid duplicates, incorrect pets may affect your application.'
export const SHARED_PETS_ALERT =
  'Do you have shared pets? Add pets to one profile only, either the Pet Owner or the Primary Applicant’s profile. Avoid duplicates, incorrect pets may affect your application.'

export const STUDENT_DETAIL_HEADER_GUIDANCE =
  'Are you studying currently? Add your course details.'

export const BALLOT_PROPERTY_APPLY_BUTTON_LABEL = 'Enter Ballot'
export const rentalTermForBallotApplications = 36

export const VARC_TEAM_NAME = 'varc'
export const VARC_TEAM_NAME2 = 'varc2'
export const MIRVAC_TEAM_NAME = 'mirvac'
export const QLD_AFFORDABLE_TEAM_NAME = 'HERSlimited'

export const isMirvacTeam = (teamSlug) => {
  return teamSlug === MIRVAC_TEAM_NAME
}

export const APPLICATION_SUBMIT_ABOUT_US_PLACEHOLDER =
  'Feel free to provide a few sentences about your household for the property manager.'

export const BANK_STATEMENT_BALANCE_ONLY_GUIDANCE =
  'In Victoria, South Australia and Queensland, property providers may not request daily transaction statements, only a savings balance statement header or redacted (blanked out) statement can be requested.'

export const BANK_STATEMENT_TEXT_PROFILE_PAGE =
  'Providing a savings balance and bank statements helps confirm your capacity and history of paying rent. ' +
  BANK_STATEMENT_BALANCE_ONLY_GUIDANCE

export const BANK_STATEMENT_TEXT_PROFILE_PAGE_QLD =
  'You can include a current Bank statement balance (with full name and date, without transaction details) or proof of savings or assets.'

export const OTHER_DOCUMENT_PROFILE_TEXT =
  'Please attach other documents to support your rental application where relevant e.g. employment Letter of Offer, proof of property ownership (Council Rates Notice), self-employment (Letter from Accountant or Financial Statements) etc.'

export const BALLOT_SURVEY_INTRODUCTION_TEXT =
  'Help Homes Victoria improve the affordable housing programmes by completing this short, anonymous survey. This survey responses does not affect your application.'

export const AFFORDABLE_QLD_BALLOT_SURVEY_INTRODUCTION_TEXT =
  'To assist us in improving our affordable housing programs please complete this short anonymous survey. Your survey responses will not affect your application.'

export const INCOME_PAYSLIPS_COUNT_RECOMMEND =
  'Payslips confirm your current income. If you are changing jobs, you might like to include the last payslip. ' +
  EMPLOYMENT_CONFIRMATION_NOTICE_SOUTH_AUSTRALIA

export const incomePayslipsDurationRecommendTxt = (duration) =>
  `Payslips confirm your current income. This property manager requires ${duration} weeks of Payslips to apply.`

export const INCOME_PAYSLIPS_COUNT_RECOMMEND_QLD =
  'If employed or between employment you can add your most recent payslip.'

export const RENT_SCHEDULE_SECTION_TITLE =
  'Would you like to pay rent weekly, fortnightly or monthly?'

export const GORVERNMENT_BENEFIT_TICKED =
  'Please include your Centrelink Income and Assessment or similar future benefits statement.'

export const GORVERNMENT_BENEFIT_TICKED_QLD =
  'You can include a Centrelink payment statement/letter below:'

// Value taken from BE
export const DefaultDisplayPrice = '$ Enquire'

export const VARC_AGENCY_GUID = '3ad8ee58-91c4-4233-b7b1-c470731e4455'

export const VARC_NO_PROPERIES_TEXT =
  'Currently no properties are available in this area.'

export const AGENCY_NO_PROPERTIES_SUFFIX =
  'does not currently have any properties available. Please click “Enquire” to get in touch.'

export const CONSOLE_CLOUD_ACTIVE = 'ACTIVE'

export const BGCHECK_ANNIVERSARY_EMAIL_URL = 'unsubscribe-bgc'

export const MODAL_BODY_APPLICATION_CLOSED =
  'This property is no longer taking applications. Please view the list of available properties and re-use your profile to apply.'

export const NOT_SOLICITED_TO_RENT_BID_MSG =
  'Please confirm that you have not been solicited by this agent/agency to rent bid.'

export const NOT_SOLICITED_TO_RENT_BID_MODAL_MSG = `By submitting an application with a rent offer above the advertised rent for this property, you confirm the declaration: I have not been solicited by this agent/agency to rent bid.`

export const BGC_LEARN_MORE_URL =
  'https://help.snug.com/hc/en-us/articles/360000132475'

export const PRE_APPLY_PREFERENCE =
  'Require Pre-Apply before viewing, not after'
export const PRE_APPLY_PREFERENCE_TOOLTIP_ID = 'preApplyInfo'
export const PRE_APPLY_PREFERENCE_TOOLTIP_CONTENT = (
  <span>
    Display pre-apply details in enquiry responses and property page. Hides open
    homes and viewing schedule.
  </span>
)

export const REQUIRE_VIEWING_BEFORE_APPLY_PREFERENCE =
  'Require viewing before applying'
export const REQUIRE_VIEWING_BEFORE_APPLY_PREFERENCE_TOOLTIP_ID =
  'requireViewingBeforeApply'
export const REQUIRE_VIEWING_BEFORE_APPLY_PREFERENCE_TOOLTIP_CONTENT = (
  <span>
    Require one of the applicants to have been checked in at a viewing or viewed
    the virtual tour for this property before an application can be submitted.
  </span>
)

export const DECLINE_OTHER_HOUSEHOLD_TOOLTIP_CONTENT = (
  <span>Takes a moment to process. If required, reload applications list.</span>
)

export const ADMIN_ACTIVE_DOMAIN_MODAL_TEXT =
  "Activating this Domain Agency ID may result in incorrect properties linking. Please confirm you're authorised and would like to activate for your team."

export const NON_ADMIN_ACTIVE_DOMAIN_MODAL_TEXT =
  'Only users who are administrators in both teams can activate.'

export const CRA_POLICY_TEXT =
  'As the homes are owned by the Victorian Government, Homes Victoria affordable properties do not qualify for Commonwealth Rent Assistance under current Commonwealth Government policy.'

export const RENTAL_LEDGER_RENTER_LEARN_MORE_LINK =
  'https://help.snug.com/hc/en-us/articles/7792805830927'

export const SHARE_APPLICATION_WITH_OWNER_NOTICE_TEXT =
  'Check out the new share application summary released 12 Oct 2023'

export const SHOW_AUTORESPONDER_MESSAGES_SCREEN =
  'showAutoresponderMessagesScreen'

export const HIDE_AUTORESPONDER_MESSAGES_SCREEN_STORAGE_KEY =
  'hideAutoresponderMessagesScreenKey'

export const NEW_LOGIN_INFO_NOTICE =
  "We've improved the login experience with Two-Factor verification."
export const NEW_LOGIN_MIGRATION_WARNING_NOTICE =
  'The next time you log in you will be prompted for Two-Factor verification. Please ensure you have access to the mobile number and email address registered for your user account.'
export const NEW_LOGIN_LEARN_MORE_LINK =
  'https://help.snug.com/hc/en-us/articles/8570304568591'

export const AUSTRALIAN_DOLLAR_PLACEHOLDER = 'Australian dollars'

export const errorMessageForInvalidFileTypeDoc = (name = '') =>
  `The file extension of ${name} is invalid, supported: pdf, doc, xlsx, png, jpg, jpeg`

export const errorMessageForInvalidFileTypeImage = (name = '') =>
  `The file extension of ${name} is invalid, supported: png, jpg, jpeg`

export const SUBTEXT_FILE_UPLOAD_ALL_FILES =
  '(max 10mb - pdf, doc, xlsx, png, jpg, jpeg)'

export const SUBTEXT_FILE_UPLOAD_IMAGE_FILES = '(max 10mb - png, jpg, jpeg)'

export const NOT_AVAILABLE_TEXT = 'Not Available'

export const NEXT_GEN_LEASING_URL =
  'https://help.snug.com/hc/en-us/articles/10809279708559-Next-Gen-Leasing'

export const RENTER_SUMMARY = 'rentersummary'

export const PROFILE_REMOVAL_POLICY =
  "State regulations may require your Renter Profile and Applications to be removed after a standard period or extended period with consent. (Only if you've applied for a property in a state with such regulations.)"

export const BG_CHECK_ASTERISK_NSW_SA_STRING =
  '*In SA, NSW, QLD and VIC, a Background Check is not requested by the agent or Snug, nor is it attached to a rental application. A Background Check is an optional data service.'

export const BG_CHECK_ASTERISK_NSW_SA_CONTENT = (
  <Text
    fontSize={theme.fontSizes[4] + 'px'}
    fontWeight={theme.fontWeights[3]}
    mt={8}
    color="pdfGray"
  >
    {BG_CHECK_ASTERISK_NSW_SA_STRING}
  </Text>
)

export const RENTER_BGC_ELIGIBILITY_ALERT_TEXT =
  'Background Checks are not available for applicants or rental properties located in South Australia, New South Wales, Queensland or Victoria'

export const mapMgmtTypeWithBE = (managementType) => {
  switch (managementType) {
    case '1':
    case 1:
      return 0
    case '2':
    case 2:
      return 1
    case '3':
    case 3:
      return 2
    default:
      return null
  }
}

export const SIGHTED_ID_ALERT_TEXT =
  'You will be required to present physical ID as requested by the agency if your application is successful. Existing ID information in your profile will not be shared.'

export const VIC_MINIMUM_STANDARDS_TEXT =
  'Record Victorian Consumer Affairs Minimum Standards confirmation for all Victorian uploaded properties. This will be visible on the property publishing options page and in the team activity feed.'
